import React from 'react';
import { JdsButton } from '../../../../components/jds/JdsButton';
import { JdsSearchInput } from '../../../../components/jds/JdsSearchInput';
import { PlusIcon } from '../../../../components/jds/icons';

export function Actions({
  filterText,
  onFilter,
  onClear,
  activeOnly,
  onActiveOnlyChange,
  onAddClick,
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 'var(--space-8)',
        width: '100%',
      }}
    >
      <label
        htmlFor="coupon-active-only"
        className="d-flex align-items-center mb-0"
        style={{ gap: 'var(--space-8)', cursor: 'pointer' }}
      >
        <span className="switch switch-sm switch-primary">
          <input
            id="coupon-active-only"
            type="checkbox"
            checked={activeOnly}
            onChange={onActiveOnlyChange}
          />
          <span />
        </span>
        Exibir apenas ativos
      </label>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 'var(--space-8)',
        }}
      >
        <JdsSearchInput
          id="coupon-code-search"
          placeholder="Buscar por código"
          filterText={filterText}
          onFilter={onFilter}
          onClear={onClear}
        />
        <JdsButton onClick={onAddClick} aria-label="Novo cupom">
          Novo cupom
          <PlusIcon />
        </JdsButton>
      </div>
    </div>
  );
}
